import * as React from "react";
import SeguroDeBicicletaContainer from "../containers/seguro-de-bicicleta-container";

export default function BicicletaPage({ data }) {
  return <SeguroDeBicicletaContainer data={data}></SeguroDeBicicletaContainer>;
}
